import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import BotConfig from './pages/BotConfig';
import ScriptEditor from './pages/ScriptEditor';
import ServerSettings from './pages/ServerSettings';
import Profiles from './pages/Profiles';
import MysticBots from './pages/MysticBots';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/bot-config" element={<BotConfig />} />
        <Route path="/scripts" element={<ScriptEditor />} />
        <Route path="/scripts/:path" element={<ScriptEditor />} />
        <Route path="/server" element={<ServerSettings />} />
        <Route path="/profiles" element={<Profiles />} />
        <Route path="/mystic-bots" element={<MysticBots />} />
      </Routes>
    </Layout>
  );
}

export default App;
